import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.5 0h-18A1.5 1.5 0 0 0 0 1.5v11.99a1.5 1.5 0 0 0 1.5 1.5h18a1.5 1.5 0 0 0 1.5-1.5V1.5A1.5 1.5 0 0 0 19.5 0m0 1.5v2.334h-18V1.5zm-18 12h18V5.334h-18zM18 11.25a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 .75.75m-6.75.75a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }